import { type ThemeConfig } from "antd";

export const lightMode: ThemeConfig = {
  token: {
    fontFamily: `
    'YekanBakh-Bold', 
    'YekanBakh-SemiBold', 
    'YekanBakh-Regular', 
  `,
  },
  components: {
    Button: {
      paddingContentHorizontal: 16,
      paddingContentVertical: 10,
      defaultBorderColor: "rgb(37,92,255)",
      defaultColor: "rgb(37,92,255)",
      colorPrimary: "rgb(37,92,255)",
      dangerShadow: "0 0px 0 rgba(255,38,5,0.06)",
      defaultShadow: "0 0px 0 rgba(0,0,0,0.02)",
      primaryShadow: "0 0px 0 rgba(5,145,255,0.1)",
      defaultBg: "rgba(255,255,255,0)",
      borderRadius: 8,
      fontSize: 16,
      controlHeight: 42,
      colorError: "rgb(237,71,62)",
      colorErrorBg: "rgb(237,71,62)",
    },
    Menu: {
      groupTitleColor: "#ADADAD",
      subMenuItemBg: "transparent",
      itemSelectedColor: "#255cff",
      itemSelectedBg: "#eef4ff",
      itemHoverColor: "#255cff",
      itemHoverBg: "#eef4ff",
      iconSize: 24,
    },
    Table: {
      headerBg: "#F5F7F9",
      headerSplitColor: "transparent",
    },
    Select: {
      controlHeight: 42,
      borderRadius: 8,
      colorBorder: "#DFDFDF",
    },
    Input: {
      controlHeight: 42,
      borderRadius: 8,
      colorBorder: "#DFDFDF",
    },
    InputNumber: {
      controlHeight: 42,
      borderRadius: 8,
      colorBorder: "#DFDFDF",
    },
    Tag: {
      borderRadius: 9999,
    },
    Modal: {
      borderRadius: 24,
    },
    Form: {
      labelColor: "#676767",
    },
    Tabs: {
      itemSelectedColor: "rgb(54,54,54)",
      itemHoverColor: "rgb(54,54,54)",
      itemActiveColor: "rgb(54,54,54)",
      inkBarColor: "rgb(54,54,54)",
      itemColor: "rgb(103,103,103)",
      colorBorderSecondary: "rgb(223,223,223)",
    },
    Upload: {
      colorFillAlter: "transparent",
    },
  },
};
